async function t(t,a){return await t.request({method:"wallet_watchAsset",params:a})}export{t as watchAsset};
